module.exports = __webpack_public_path__ + "static/media/dot-deco.6c02b980.svg";